import React from 'react';
import classnames from 'classnames';
import Icon from '@kid/enterprise-icon/icon/output/Icon.js';
import css from './KdevIconFont.less';

const icons = {};
interface IProps {
    id: string | Array<any>;
    size?: number;
    color?: string;
    style?: React.CSSProperties;
    className?: string;
}

const ICON_STYLE: React.CSSProperties = {
    width: '1em',
    height: '1em',
    verticalAlign: '-0.15em',
    fill: 'currentColor',
    overflow: 'hidden',
};

export class KdevIconFont extends React.Component<IProps, any> {
    public render() {
        const { id, size = 16, color = '', className } = this.props;
        const config = typeof id === 'string' ? icons[id] : id;
        const props = this.props ? this.props : {};
        const style = this.props.style ? this.props.style : {};
        if (typeof id === 'string' && id[0] === '#') {
            // 传统的图标
            return (
                <svg
                    {...props}
                    className={classnames('icon', className)}
                    aria-hidden="true"
                    style={{ ...ICON_STYLE, ...style }}
                >
                    <use xlinkHref={id} />
                </svg>
            );
        }
        if (typeof id === 'string' && id[0] !== '#') {
            // 接口返回的图标，需要通过url拼接
            const width = this.props.style?.fontSize || '16px';
            return (
                <img
                    src={`https://s2-11289.kwimgs.com/kos/nlav11289/36/${id}.png`}
                    style={{ width: width }}
                    className={classnames('iconImg', className)}
                />
            );
        }
        return (
            <Icon
                {...props}
                config={config}
                size={size}
                color={color}
                style={{ ...ICON_STYLE, ...style }}
                className={classnames(css.icon, className)}
            />
        );
    }
}
